<template>
  <Layout :removePadding="true" :onlyLogoHeader="true">
    <div
      class="text-center primary--text display font-weight-bold"
      :class="$vuetify.breakpoint.smAndDown ? 'pt-3 pb-0' : 'pt-10 pb-5'"
    >
      {{ $t("headers.sign_up_title") }}
      <p class="text-center primary--text font-weight-light subtitle-2 pt-2">
        {{ $t("headers.sign_up_type") }}
      </p>
    </div>
    <div class="mt-13 mx-10">
      <OptionButton
        v-for="(button, i) in optionButtons"
        v-if="button.active"
        :key="i"
        :icon="button.icon"
        :custom_icon="button.custom_icon"
        :label="button.text"
        class="mb-3"
        :bg_secondary_color="true"
        @click.native="
          $router.push({
            name: routeNames.SIGN_UP,
            params: { type: button.type },
          })
        "
      />
    </div>
    <p class="text-center primary--text pt-10">
      {{ $t("headers.sign_up_already") }}
      <span
        class="font-weight-bold clickable"
        @click="$router.push({ name: routeNames.LOGIN })"
        >{{ $t("headers.sign_in") }}</span
      >
    </p>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/MainLayout";
import routeNames from "@/router/route-names";
import OptionButton from "@/components/form-elements/BigButton";

export default {
  name: "SignUpView",
  data() {
    return {
      routeNames: routeNames,
      optionButtons: {
        ticket: {
          icon: "confirmation_number",
          text: this.$t("sign_up_options.locator"),
          type: "locator",
          active: false,
        },
        tag: {
          custom_icon: "tag",
          icon: "watch",
          text: this.$t("sign_up_options.tag"),
          type: "tag",
          active: false,
        },
        no_reference: {
          icon: "mail",
          text: this.$t("sign_up_options.email"),
          type: "no_reference",
          active: false,
        },
      },
    };
  },
  methods: {
    linkOptions() {
      const link_array = this.$store.getters.customization.link_array;

      if (link_array.length == 1) {
        this.$router.push({
          name: routeNames.SIGN_UP,
          params: {
            type: this.optionButtons[link_array[0]].type,
            singleType: true,
          },
        });
      }

      link_array.map((element) => {
        this.optionButtons[element].active = true;
      });
    },
  },
  async created() {
    await this.linkOptions();
  },
  components: {
    Layout,
    OptionButton,
  },
};
</script>
